// extracted by mini-css-extract-plugin
module.exports = {"icon":"Tooltip__icon___1tW19","bordered":"Tooltip__bordered___7bkkf","content":"Tooltip__content___1tEBD","inverse":"Tooltip__inverse___yk5z0"};